import React from 'react';
import { Select } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { typesSelector } from '../../../../store/selectors';
import useInfoTypes from '../../../../queries/useInfoTypes';
import { setFilterState } from '../../../../store/actions';
import { getInfoTypeIcon } from '../../../../utils';
import { filterNames } from '../../../../constants/common';
import styles from './SelectTypews.module.scss';

const SelectTypes = ({ className }) => {
  const dispatch = useDispatch();
  const selectedTypes = useSelector(typesSelector);

  const { data: types, isFetching } = useInfoTypes({
    staleTime: Infinity,
  });

  const handleChange = (value) => {
    dispatch(setFilterState({ filterName: filterNames.types, value }));
  };

  return (
    <Select
      className={className}
      loading={isFetching}
      mode="multiple"
      defaultActiveFirstOption={false}
      allowClear={true}
      placeholder="Тема"
      value={types ? selectedTypes : []}
      onChange={handleChange}
    >
      {types?.map((type) => (
        <Select.Option key={type.id} value={type.id}>
          <div className={styles.option}>
            {getInfoTypeIcon(type.id, 16)}
            {type.name}
          </div>
        </Select.Option>
      ))}
    </Select>
  );
};

export default SelectTypes;
